import { z } from 'zod'
import type { AITool } from './types'
import { createHevyFolder } from '../../services/hevyPushService'

// Parameters schema
const parametersSchema = z.object({
  name: z.string()
    .min(1)
    .max(100)
    .describe('Name of the routine folder (e.g., "Push/Pull/Legs Split", "Beginner Program", "Powerlifting Block")')
})

export const createRoutineFolder: AITool = {
  name: 'createRoutineFolder',
  description: 'Create routine folder in Hevy.',
  parameters: parametersSchema,
  
  execute: async (args, context) => {
    const { name } = args
    
    // Check if user has Hevy API credentials configured
    if (!context.userCredentials?.apiKey) {
      throw new Error('Hevy API key not configured. Please set up your Hevy API key in Settings > Credentials.')
    }

    const apiKey = context.userCredentials.apiKey

    try {
      // Call Hevy API to create routine folder
      const folder = await createHevyFolder(apiKey, name.trim())

      // Return success response
      return {
        success: true,
        folder_name: folder.title,
        folder_id: folder.id,
        message: `Created routine folder "${folder.title}" successfully. You can now create routines within this folder.`
      }
    } catch (error) {
      console.error('Error creating routine folder:', error)
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Unknown error occurred',
        message: `Failed to create routine folder "${name.trim()}". Please try again or check your Hevy API key configuration.`
      }
    }
  }
}